import messages from '../../intl/messages';

// mechanical mapping evt -> messages key, e.g. 'socket.connect' -> 'mobileLogEvtSocketConnect'
const evtMessageKey = (evt) => {
	const pascal = String(evt)
		.split(/[._]/)
		.filter(Boolean)
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join('');

	return `mobileLogEvt${pascal}`;
};

// evt -> messages entry, always falling back so a newer evt code from the mobile app never
// renders as a raw string on its own (mirrors the monitoringFlagUnknown pattern)
export const getEvtMessage = (evt) => messages[evtMessageKey(evt)] ?? null;

const CATEGORY_MESSAGE_KEYS = {
	socket: 'mobileLogCatSocket',
	camera: 'mobileLogCatCamera',
	rec: 'mobileLogCatRec',
	upload: 'mobileLogCatUpload',
	azure: 'mobileLogCatAzure',
	idb: 'mobileLogCatIdb',
	screenshot: 'mobileLogCatScreenshot',
	net: 'mobileLogCatNet',
	app: 'mobileLogCatApp',
	error: 'mobileLogCatError',
	device: 'mobileLogCatDevice',
	heartbeat: 'mobileLogCatHeartbeat',
	mobile: 'mobileLogCatMobile',
};

export const getCategoryMessage = (category) => messages[CATEGORY_MESSAGE_KEYS[category]] ?? messages.mobileLogCatUnknown;

export const CATEGORY_LIST = Object.keys(CATEGORY_MESSAGE_KEYS);
